import { defineMessages } from 'react-intl';

export default defineMessages({
  paymentOptions: {
    id: 'fastCover.stepPaymentDetails.paymentOptions',
    defaultMessage: 'Payment Options',
  },
  paymentTo: {
    id: 'fastCover.stepPaymentDetails.paymentTo',
    defaultMessage: 'Payment To',
  },
  paymentVia: {
    id: 'fastCover.stepPaymentDetails.paymentVia',
    defaultMessage: 'Payment Via',
  },
  memberInsured: {
    id: 'fastCover.stepPaymentDetails.memberInsured',
    defaultMessage: 'Member / Insured',
  },
  familyMember: {
    id: 'fastCover.stepPaymentDetails.familyMember',
    defaultMessage: 'Family Member',
  },
  provider: {
    id: 'fastCover.stepPaymentDetails.provider',
    defaultMessage: 'Provider',
  },
  check: {
    id: 'fastCover.stepPaymentDetails.check',
    defaultMessage: 'Check (only for US address)',
  },
  EFT: {
    id: 'fastCover.stepPaymentDetails.EFT',
    defaultMessage: 'EFT (Recommended)',
  },
  paymentDetails: {
    id: 'fastCover.stepPaymentDetails.paymentDetails',
    defaultMessage: 'Payment Details',
  },
  bankDetails: {
    id: 'fastCover.stepPaymentDetails.bankDetails',
    defaultMessage: 'Bank Details',
  },
  accountName: {
    id: 'fastCover.stepPaymentDetails.accountName',
    defaultMessage: 'Account Name',
  },
  bankName: {
    id: 'fastCover.stepPaymentDetails.bankName',
    defaultMessage: 'Bank Name',
  },
  accountNumber: {
    id: 'fastCover.stepPaymentDetails.accountNumber',
    defaultMessage: 'Account Number',
  },
  bankRoutingNumber: {
    id: 'fastCover.stepPaymentDetails.bankRoutingNumber',
    defaultMessage: 'Bank Routing Number',
  },
  checkAddress: {
    id: 'fastCover.stepPaymentDetails.checkAddress',
    defaultMessage: 'Check Address (if different then claimants address)',
  },
  title: {
    id: 'fastCover.stepPaymentDetails.title',
    defaultMessage: 'Title',
  },
  firstName: {
    id: 'fastCover.stepPaymentDetails.firstName',
    defaultMessage: 'First Name',
  },
  lastName: {
    id: 'fastCover.stepPaymentDetails.lastName',
    defaultMessage: 'Last Name',
  },
  addressLine1: {
    id: 'fastCover.stepPaymentDetails.addressLine1',
    defaultMessage: 'Address Line 1',
  },
  addressLine2: {
    id: 'fastCover.stepPaymentDetails.addressLine2',
    defaultMessage: 'Address Line 2',
  },
  country: {
    id: 'fastCover.stepPaymentDetails.country',
    defaultMessage: 'Country',
  },
  state: {
    id: 'fastCover.stepPaymentDetails.state',
    defaultMessage: 'State',
  },
  city: {
    id: 'fastCover.stepPaymentDetails.city',
    defaultMessage: 'City',
  },
  postalZipCode: {
    id: 'fastCover.stepPaymentDetails.postalZipCode',
    defaultMessage: 'Postal / Zip Code',
  },
  mobile: {
    id: 'fastCover.stepPaymentDetails.mobile',
    defaultMessage: 'Mobile',
  },
  //-----------------
  whatIsYourABN: {
    id: 'fastCover.stepPaymentDetails.whatIsYourABN',
    defaultMessage: 'What is your Australian Business Number (ABN)?',
  },
  claimITC: {
    id: 'fastCover.stepPaymentDetails.claimITC',
    defaultMessage: 'Have you claimed or are you entitled to claim an Input Tax Credit (ITC) in respect to the GST paid on the insurance policy under which this claim is being made?',
  },
  whatPercentageOfGST: {
    id: 'fastCover.stepPaymentDetails.whatPercentageOfGST',
    defaultMessage: 'What percentage of GST did you claim or are entitled to claim?',
  },
  yes: {
    id: 'fastCover.stepPaymentDetails.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepPaymentDetails.no',
    defaultMessage: 'No',
  },
  weCannotDepositIntoACreditCardAccount: {
    id: 'fastCover.stepPaymentDetails.weCannotDepositIntoACreditCardAccount',
    defaultMessage: 'We cannot deposit into a credit card account or overseas bank account.',
  },
  paymentRequiredMessage: {
    id: 'fastCover.stepPaymentDetails.paymentRequiredMessage',
    defaultMessage: 'If we are required to make a payment on your behalf, no payment will be made until we receive payment from you of any applicable excess.',
  },
  nameOfBank: {
    id: 'fastCover.stepPaymentDetails.nameOfBank',
    defaultMessage: 'Name of Bank',
  },
  branch: {
    id: 'fastCover.stepPaymentDetails.branch',
    defaultMessage: 'Branch Name',
  },
  bsbNumber: {
    id: 'fastCover.stepPaymentDetails.bsbNumber',
    defaultMessage: 'Branch Code (BSB)',
  },
  accountHolder: {
    id: 'fastCover.stepPaymentDetails.accountHolder',
    defaultMessage: 'Account Name',
  },
  GSTInfo: {
    id: 'fastCover.stepPaymentDetails.GSTInfo',
    defaultMessage: 'GST information - applicable if your policy was purchased for a business',
  },
  areYouRegisteredForGTSPurposes: {
    id: 'fastCover.stepPaymentDetails.areYouRegisteredForGTSPurposes',
    defaultMessage: 'Are you registered for GST Purposes?',
  },
  pleaseNote: {
    id: 'fastCover.stepPaymentDetails.pleaseNote',
    defaultMessage: 'Please note',
  },
  depositMessage: {
    id: 'fastCover.stepPaymentDetails.depositMessage',
    defaultMessage: 'If your claim is approved and where a cash settlement applies, we will deposit your settlement directly into your nominated bank account.',
  },
  bsbNumberLengthValidation: {
    id: 'fastCover.stepPaymentDetails.bsbNumberLengthValidation',
    defaultMessage: 'BSB Number is 6 digits only.',
  },
  bsbCannotBeVerified: {
    id: 'fastCover.stepPaymentDetails.bsbCannotBeVerified',
    defaultMessage: 'BSB number cannot be verified',
  },
  notice: {
    id: 'fastCover.stepPaymentDetails.notice',
    defaultMessage: 'The BSB Number you have entered could not be verified.',
  },
  noticeIntruction: {
    id: 'fastCover.stepPaymentDetails.noticeIntruction',
    defaultMessage: 'To continue any way, please tick the checkbox and manually enter the remaining fields.',
  },
  invalidBSBWarning: {
    id: 'fastCover.stepPaymentDetails.invalidBSBWarning',
    defaultMessage: 'The entered BSB number is not found in our records, tick the checkbox in order to successfully submit the claim.',
  },
  doYouHaveAnotherOtherInsurance: {
    id: 'fastCover.stepPaymentDetails.doYouHaveAnotherOtherInsurance',
    defaultMessage:
      'Do you have any other insurance that would cover all or part of your loss?',
  },
  exampleHomeContentsInsurance: {
    id: 'fastCover.stepPaymentDetails.exampleHomeContentsInsurance',
    defaultMessage:
      'e.g. Home Contents insurance, Private Health Fund, Credit Card',
  },
  ifYesPleaseProvideDetails: {
    id: 'fastCover.stepPaymentDetails.ifYesPleaseProvideDetails',
    defaultMessage: 'If yes, please provide details',
  },
  isRequired: {
    id: 'fastCover.stepPaymentDetails.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  isMaxLength: {
    id: 'fastCover.stepPaymentDetails.isMaxLength',
    defaultMessage: "'{defaultMessage}' maximum length has been exceeded",
  },
  //-----------------
  bankTypeCode: {
    id: 'fastCover.stepPaymentDetails.bankTypeCode',
    defaultMessage: 'Bank Type Code',
  },
  bankCode: {
    id: 'fastCover.stepPaymentDetails.bankCode',
    defaultMessage: 'Bank Code',
  },
  swiftCode: {
    id: 'fastCover.stepPaymentDetails.swiftCode',
    defaultMessage: 'Swift Code',
  },
  IBANText: {
    id: 'fastCover.stepPaymentDetails.IBAN',
    defaultMessage: 'IBAN',
  },
  bankCodeOrRoutingNumber: {
    id: 'fastCover.stepPaymentDetails.bankCodeOrRoutingNumber',
    defaultMessage: 'Bank Code / Routing Number',
  },
  validate: {
    id: 'fastCover.stepPaymentDetails.validate',
    defaultMessage: 'Validate',
  },
  bank: {
    id: 'fastCover.stepPaymentDetails.bank',
    defaultMessage: 'Bank',
  },
  bankAddress: {
    id: 'fastCover.stepPaymentDetails.bankAddress',
    defaultMessage: 'Bank Address',
  },
  bankSuburbOrCity: {
    id: 'fastCover.stepPaymentDetails.bankSuburbOrCity',
    defaultMessage: 'Bank Suburb/City',
  },
  bankPostcode: {
    id: 'fastCover.stepPaymentDetails.bankPostcode',
    defaultMessage: 'Bank Postcode',
  },
  bankBranch: {
    id: 'fastCover.stepPaymentDetails.bankBranch',
    defaultMessage: 'Bank Branch',
  },
  bankAccountName: {
    id: 'fastCover.stepPaymentDetails.bankAccountName',
    defaultMessage: 'Account Name',
  },
  bankAccountNumber: {
    id: 'fastCover.stepPaymentDetails.bankAccountNumber',
    defaultMessage: 'Bank Account Number',
  },
  reminderIban: {
    id: 'fastCover.stepPaymentDetails.reminderIban',
    defaultMessage: 'Contains two-letter country code, two check digits, followed by up to 35 letters/numbers (No spaces or dashes)',
  },
  isValidAccountNumber: {
    id: 'fastCover.stepPaymentDetails.isValidAccountNumber',
    defaultMessage: 'Bank Account Number maximum length needs to be 17 characters or less',
  },
  isValidBankCode: {
    id: 'fastCover.stepPaymentDetails.isValidBankCode',
    defaultMessage: 'Bank Code / Routing Number maximum length needs to be 32 characters or less',
  },
  isValidUASBankCode: {
    id: 'fastCover.stepPaymentDetails.isValidUASBankCode',
    defaultMessage: 'The bank routing number entered should be 9 numeric digits, please recheck and enter again.',
  },
  isValidSwiftCode: {
    id: 'fastCover.stepPaymentDetails.isValidSwiftCode',
    defaultMessage: 'Swift code maximum length needs to be 11 characters or less',
  },
  isValidIban: {
    id: 'fastCover.stepPaymentDetails.isValidIban',
    defaultMessage: 'IBAN code maximum length needs to be 34 characters or less',
  },
  confirmSelectCountry: {
    id: 'fastCover.stepPaymentDetails.confirmSelectCountry',
    defaultMessage: 'If your country is not listed in the drop-down options, please change your payment method selection from EFT to Check.',
  },
  isValidBankAccountName: {
    id: 'fastCover.stepPaymentDetails.isValidBankAccountName',
    defaultMessage: 'Bank Account Name maximum length needs to be 128 characters or less',
  },
  bankCodeOrRoutingNumber9Digits: {
    id: 'fastCover.stepPaymentDetails.bankCodeOrRoutingNumber9Digits',
    defaultMessage: 'Bank Code / Routing Number (Must be 9 digits)',
  },
  bankBranchName: {
    id: 'fastCover.stepPaymentDetails.bankBranchName',
    defaultMessage: 'Bank Branch Name',
  },
  pleaseAttachTheWireTransfer: {
    id: 'fastCover.stepPaymentDetails.pleaseAttachTheWireTransfer',
    defaultMessage: 'Please attach the wire transfer instructions from your financial institution (this can be obtained via online baking app, website or a call to the bank).',
  },
  alternativelyText: {
    id: 'fastCover.stepPaymentDetails.alternativelyText',
    defaultMessage: 'Alternatively, if you wish to receive payment via check please select this checkbox. Payments made via check take longer to be processed while EFT payments are received faster.',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepPaymentDetails/messages.js